import React from 'react';

import { GridValidRowModel } from '@mui/x-data-grid';

import { defaultOperators } from 'components/Grid';
import { ColumnDefinition } from 'components/Grid/types';
import { GroupStatusOperator, GroupTypeOperator } from 'components/Grid/operators/Status';

import GroupStatusChip from 'components/Chips/GroupStatusChip';
import GroupTypeChip from 'components/Chips/GroupTypeChip';

import { MembershipMode } from 'utils/api/modules/memberGroups';

import { DescriptionCell, NameCell } from '../styles';

export const basicColumns = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 200,
    filterOperators: defaultOperators.short_text(),
    nativeFilter: true, // → ?name=<value> (icontains); distinct from the combined quick-search ?query=
    renderCell: ({ row }: { row: GridValidRowModel }) => <NameCell>{row.name}</NameCell>,
  },
  {
    field: 'active',
    headerName: 'Status',
    minWidth: 130,
    flex: 0.6,
    sortable: false,
    renderCell: ({ value }: { value: boolean }) => <GroupStatusChip isActive={value} />,
    filterOperators: GroupStatusOperator(),
    nativeFilter: true,
    valueFormatter: (params: { value: boolean } | null) => (params ? (params.value ? 'Active' : 'Inactive') : ''),
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 1.4,
    minWidth: 240,
    sortable: false,
    filterOperators: defaultOperators.short_text(),
    nativeFilter: true, // → ?description=<value> (icontains)
    renderCell: ({ value }: { value: string }) => <DescriptionCell title={value}>{value}</DescriptionCell>,
  },
  {
    field: 'membershipMode',
    headerName: 'Membership type',
    minWidth: 160,
    sortable: false,
    renderCell: ({ value }: { value: MembershipMode }) => <GroupTypeChip type={value} />,
    filterOperators: GroupTypeOperator(),
    nativeFilter: 'type',
    valueFormatter: (params: { value: MembershipMode } | null) =>
      params ? (params.value === MembershipMode.Dynamic ? 'Dynamic' : 'Manual') : '',
  },
  {
    field: 'memberCount',
    headerName: 'Members',
    flex: 1,
    minWidth: 200,
    sortable: false,
    // Filtered by member, displayed as a count — the avatar preview was dropped for performance.
    filterOperators: defaultOperators.user(),
    nativeFilter: 'members',
    valueFormatter: (value: number | null) => String(value ?? 0),
  },
] as unknown as ColumnDefinition[];
